/* eslint-disable */

import { useSelector } from "react-redux";
import LoginForm from "./LoginForm";
import { useEffect } from "react";

const LoginPage = () => {
  const preference = JSON.parse(localStorage.getItem("userLayout"))?.theme?.mode

  useEffect(() => {
    if(preference){
      document.body.setAttribute("data-theme", preference);
    }
  }, [preference]);


  return (
    <div className="loginContainer">
      <div className="right_login">
        <LoginForm />
      </div>
    </div>
  );
};

export default LoginPage;
